export default "__VITE_ASSET__ku9WxCSX__"